import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TIpRangeStatus = components['schemas']['ProviderIpRangeStatusResDto'];
export type TIpRangeRefresh = components['schemas']['ProviderIpRangeRefreshResDto'];
export type TRefreshStatus = TIpRangeRefresh['status'];

export const listIpRanges = (): Promise<TIpRangeStatus[]> => unwrap(api.GET('/v1/ip-ranges'));

export const refreshAllIpRanges = (): Promise<TIpRangeRefresh[]> =>
  unwrap(api.POST('/v1/ip-ranges/refresh'));

export const refreshIpRange = (key: string): Promise<TIpRangeRefresh[]> =>
  unwrap(api.POST('/v1/ip-ranges/{key}/refresh', { params: { path: { key } } }));
